export { default as ProductsIndexPageSubHeaderImageScaleButton } from './ProductsIndexPageSubHeaderImageScaleButton';
